import React from 'react';
import CustomDialog from 'components/CustomDialog/CustomDialog';
import { translate } from 'components/Translation';
import FileUpload from 'components/CustomUpload/FileUpload';
import CustomLink from 'components/CustomLink/CustomLink';
import VerticalAlignBottom from '@material-ui/icons/VerticalAlignBottom';
import makeStyles from '@material-ui/core/styles/makeStyles';
import styles from 'assets/jss/material-dashboard-pro-react/components/uploadFileDialogStyle';
import classNames from 'classnames';
import { BodyM } from 'components/Typography/Typography';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IUploadFileDialogProps {
	onFileChange: (value: string) => void;
	isOpen: boolean;
	hideDialog: () => void;
	uploadingCsv: boolean;
	uploadingCsvError?: string;
	sampleCsvUrl: string;
	header: string;
}

const UploadFileDialog = ({
	onFileChange,
	isOpen,
	hideDialog,
	uploadingCsv,
	uploadingCsvError,
	sampleCsvUrl,
	header,
}: IUploadFileDialogProps) => {
	const classes = useStyles();

	const fileUploaded = (base64data: string) => {
		onFileChange(base64data);
	};

	return (
		<CustomDialog
			isOpen={isOpen}
			hideDialog={hideDialog}
			header={header}
			dialogBody={
				<div
					className={classNames(classes.fileUploadDialogBody, {
						[classes.errorVisible]: uploadingCsvError,
					})}
				>
					<FileUpload
						text={translate('csv.drag.and.drop')}
						onFileChange={fileUploaded}
						loadingText={translate('importing.users')}
						loading={uploadingCsv}
						errorMessage={uploadingCsvError}
					/>
					<ConditionalRender
						show={uploadingCsv}
						onTrue={() => (
							<div className={classes.fileUploadHeader}>
								<BodyM disableMargin>{translate('it.can.take.a.while')}</BodyM>
							</div>
						)}
						onFalse={() => (
							<>
								<div className={classes.fileUploadHeader}>
									<BodyM disableMargin>{translate('dialog.how.file.needs.to.look.like')}</BodyM>
								</div>
								<CustomLink color="brand" to={sampleCsvUrl} download target="_blank" type="bodyS">
									<div className={classes.downloadLink}>
										<VerticalAlignBottom />
										{translate('click.to.download.sample')}
									</div>
								</CustomLink>
							</>
						)}
					/>
				</div>
			}
		/>
	);
};

export default UploadFileDialog;
